export default __webpack_public_path__ + "static/media/usecase_internal_sharing.295892e2.png";